import { useRouter } from 'next/router';
import { useRef } from 'react';

import { searchInputProps } from 'humanity/components/searchInput/searchInput.types.js';
import { track } from 'utils/analytics';
import { logger } from 'utils/logger';
import Input from 'humanity/primitives/input';

const SearchInput = ({ placeholder, LeftIcon, RightIcon, hasError, icon, ...props }) => {
  const router = useRouter();
  const { asPath } = router;
  const searchRef = useRef();

  const onSearch = async (e) => {
    const { key, type } = e;

    if ((type === 'keydown' && key === 'Enter') || type === 'click') {
      const searchQuery = searchRef.current.value;

      try {
        track('search_bar_used', {
          keyword: searchQuery,
          location: asPath,
        });

        router.push({
          pathname: '/learn/search',
          query: {
            searchQuery,
          },
        });
      } catch (err) {
        logger.error(`Error searching LC resources with keyword: ${searchQuery}`, e);
      }
    }
  };

  const handleFocus = () => {
    track('search_bar_focused', {
      location: asPath,
    });
  };

  return (
    <Input
      placeholder={placeholder}
      LeftIcon={LeftIcon}
      bg="white"
      onKeyDown={onSearch}
      onFocus={handleFocus}
      ref={searchRef}
      {...props}
    />
  );
};

SearchInput.propTypes = {
  ...searchInputProps,
};

export default SearchInput;
